import { ComponentView } from "binder";
import { getAsBoolean } from "../../../utilities";
import { StringFilterViewModel } from "./stringFilter-viewModel"

export class StringFilterView extends ComponentView<StringFilterViewModel>{
    GetViewUniqueId(): string {
        return "V-5F40E94D-A474-4B2E-9C0F-56E330971227"
    }
    loadHtml(): string {
        let element = require('./stringFilter.html').default;
        let style = require('./stringFilter.less');
        return element;
    }
    constructor() {
       super();
    }

    public set containsValue(v: string) { this._containsValue = v; } public get containsValue(): string { return this._containsValue;} private _containsValue: string;
    public set isActive(v: boolean) { this._isActive = getAsBoolean(v); } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    
    apply(){
        this.isActive = true;
        this.dataContext.apply();
    }

    
    removeFilter(){
        this.isActive = false;
        this.dataContext.apply();
    }
}
